import { MultipleSelect, TextInput } from "@normasteaching/norma-ui";
import { PropsWithChildren } from "react";
import { PaymentMethodConfigComponentProps } from "./PaymentMethodConfiguration.ts";
import { Controller } from "react-hook-form";

function InputWithLabel({
  children,
  label,
}: PropsWithChildren<{ label: string }>) {
  return (
    <div className={"flex flex-col gap-1 flex-1"}>
      <label className={"font-medium"}>{label}</label>
      {children}
    </div>
  );
}

export function HeyLightConfigFields({
  fieldName,
  register,
  errors,
  control,
}: PaymentMethodConfigComponentProps) {
  const configErrors = errors[fieldName as keyof typeof errors] as unknown as {
    successUrl: { message: string };
    failureUrl: { message: string };
    allowedTerms: { message: string };
  };

  return (
    <div className="bg-blue-50 p-4 rounded-lg space-y-4">
      <InputWithLabel label="URL di successo">
        <TextInput
          {...register(`${fieldName}.successUrl`)}
          errorMessage={configErrors?.successUrl?.message}
          placeholder="es: https://fluentepersempre.normasteaching.com/buyer-thank-you"
        />
      </InputWithLabel>
      <InputWithLabel label="URL di fallimento">
        <TextInput
          {...register(`${fieldName}.failureUrl`)}
          errorMessage={configErrors?.failureUrl?.message}
          placeholder="es: https://fluentepersempre.normasteaching.com/buyer-failed"
        />
      </InputWithLabel>
      <InputWithLabel label={"Rate disponibili"}>
        <Controller
          {...register(`${fieldName}.allowedTerms`)}
          control={control}
          render={({ field }) => {
            return (
              <MultipleSelect
                errorMessage={configErrors?.allowedTerms?.message}
                searchable
                value={
                  field.value?.map((v: number): string => v.toString()) ?? []
                }
                onChange={(v) => {
                  return field.onChange(v.map((s) => parseInt(s, 10)));
                }}
                options={Array.from(
                  {
                    length: 22,
                  },
                  (_, i) => ({
                    id: (i + 3).toString(),
                    label: `${i + 3} rate`,
                  }),
                )}
              />
            );
          }}
        />
      </InputWithLabel>
    </div>
  );
}
